import styled, { css } from "styled-components"

import goldCoin from "images/character/gold_coin-66x68.png"
import shineEffect from "images/effect/shine_effect-16x22.png"

export default function RefundCondition({ period = 14, minAuth = 8 }) {
  const paybackPosition = 242 * (minAuth / period)
  const completeRate = (minAuth / period) * 100

  return (
    <Section>
      <SectionTitle>환급조건</SectionTitle>
      <Description>{`인증 시작 일부터 ${period}일 이내 ${minAuth}회 이상 인증 시, 환급`}</Description>
      <RefundInfoBlock>
        <ProgressBar>
          <BarPoint position={0}>
            <BarPointPin />
            <BarPointTxt>시작</BarPointTxt>
          </BarPoint>
          <BarPoint position={paybackPosition}>
            <PaybackIconPosition>
              <PaybackIconWrapper>
                <PaybackIcon src={goldCoin} />
              </PaybackIconWrapper>
              <ShineIconWrapper>
                <PaybackIcon src={shineEffect} />
              </ShineIconWrapper>
            </PaybackIconPosition>
            <BarPointPin />
            <BarPointTxt>환급</BarPointTxt>
          </BarPoint>
          <BarPoint position={242}>
            <BarPointPin isGray={true} />
            <BarPointTxt>완주</BarPointTxt>
          </BarPoint>
          <ProgressBarLine width={completeRate} />
        </ProgressBar>
        <TaskCountBlock>
          <CompleteNum>{minAuth}</CompleteNum>
          <TotalTaskNum>{period}</TotalTaskNum>
        </TaskCountBlock>
      </RefundInfoBlock>
    </Section>
  )
}

const Section = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: calc(100vw * (50 / 375));
`

const SectionTitle = styled.div`
  font-weight: 700;
  font-size: calc(100vw * (20 / 375));
  display: flex;
  align-items: center;
  color: #121212;
  margin-bottom: calc(100vw * (7 / 375));
`

const Description = styled.p`
  font-size: calc(100vw * (14 / 375));
  font-weight: 400;
  line-height: calc(100vw * (17 / 375));
  color: #4e4e4e;
  margin-bottom: calc(100vw * (24 / 375));
`

const RefundInfoBlock = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f7f8fb;
  border-radius: calc(100vw * (11 / 375));
  height: calc(100vw * (93 / 375));
  min-height: calc(100vw * (93 / 375));
  padding-right: calc(100vw * (18 / 375));
  padding-left: calc(100vw * (18 / 375));
  padding-top: calc(100vw * (10 / 375));
`

const ProgressBar = styled.div`
  position: relative;
  bottom: 0;
  display: flex;
  align-items: flex-end;
  width: calc(100vw * (242 / 375));
  height: calc(100vw * (6 / 375));
  background: #e8e8e8;
  border-radius: calc(100vw * (22 / 375));
`

const BarPoint = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  left: ${({ position }) => `calc(100vw * ((${position - 6}) / 375))`};
  top: calc(100vw * (-3 / 375));
`

const BarPointPin = styled.div`
  width: calc(100vw * (12 / 375));
  height: calc(100vw * (12 / 375));
  background-color: #ffcf19;
  border-radius: 100%;
  margin-bottom: calc(100vw * (7 / 375));
  ${({ isGray }) =>
    isGray &&
    css`
      background-color: #e8e8e8;
    `}
`

const BarPointTxt = styled.span`
  font-style: normal;
  font-weight: 500;
  font-size: calc(100vw * (12 / 375));
  color: #989898;
  white-space: nowrap;
`

const ProgressBarLine = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: ${({ width }) => width}%;
  height: calc(100vw * (6 / 375));
  background-color: #ffcf19;
  border-radius: calc(100vw * (22 / 375));
`

const TaskCountBlock = styled.div`
  flex: 0 1 auto;
  display: flex;
  align-items: center;
`

const CompleteNum = styled.span`
  font-size: calc(100vw * (20 / 375));
  font-weight: 500;
  line-height: calc(100vw * (29 / 375));
  margin-right: calc(100vw * (2 / 375));
`

const TotalTaskNum = styled.span`
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (20 / 375));
  color: #7f7f7f;

  &::before {
    content: "/";
    margin-right: calc(100vw * (2 / 375));
  }
`

const PaybackIconPosition = styled.div`
  position: relative;
`
const PaybackIconWrapper = styled.div`
  position: absolute;
  bottom: calc(100vw * (4 / 375));
  left: -50%;
  transform: translateX(-50%);
  width: calc(100vw * (27 / 375));
  height: calc(100vw * (28 / 375));
`
const ShineIconWrapper = styled.div`
  position: absolute;
  bottom: calc(100vw * (26 / 375));
  left: calc(100vw * (10.5 / 375));
  width: calc(100vw * (8 / 375));
  height: calc(100vw * (11 / 375));
`
const PaybackIcon = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`
